// src/pages/profile-settings/screens/TwoFactorPage.jsx
import React from "react";
import { SmsTwoFactorHub } from "@/pages/profile-settings/components/SmsTwoFactorSettings.jsx";

export default function TwoFactorPage() {
  return <SmsTwoFactorHub role="patient" backTo="/settings/patient/login-security" />;
}
